import { selectTotalSurveySteps } from 'store/survey/selectors';
import { useSelector } from 'react-redux';

export const useTotalQuestions = (): Record<string, number> => {
  const steps = useSelector(selectTotalSurveySteps);
  return { totalQuestions: steps };
};
